<div class="py-2.5 px-7">
  <app-section-header
    [title]="'Admin - Topic Management'"
    [preserveQueryParam]="true"
  >
    <div class="flex justify-end flex-1">
      <button
        mat-flat-button
        color="primary"
        class="ml-3"
        [routerLink]="['./', 'new']"
      >
        Add Topic
      </button>
    </div>
  </app-section-header>

  <div class="flex items-center justify-between pt-2">
    <div class="flex items-center">
      <label class="px-4 text-base font-normal font-montserrat">Site:</label>
      <mat-form-field
        [floatLabel]="'never'"
        appearance="outline"
        class="w-64"
        title="Filter topics by published site"
      >
        <mat-select [formControl]="channelFilter">
          <mat-option [value]="''">All sites</mat-option>
          <mat-option
            *ngFor="let target of deliveryTargets"
            [value]="target.code"
          >
            {{ target.friendlyName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field
      [floatLabel]="'never'"
      appearance="outline"
      class="w-1/4 author_search-box"
    >
      <input
        type="text"
        matInput
        placeholder="Search topics..."
        [formControl]="searchControl"
      />
      <mat-icon
        matSuffix
        *ngIf="searchControl.value"
        title="Clear Search"
        class="float-left ml-2 text-xl hover:text-project-300"
        (click)="clearSearch()"
        >close</mat-icon
      >
      <mat-icon
        matSuffix
        class="float-right ml-2 text-xl hover:text-project-300"
        title="Search"
        >search</mat-icon
      >
    </mat-form-field>
  </div>

  <div class="mat-elevation-z0">
    <table
      mat-table
      [dataSource]="dataSource"
      class="w-full max-w-full mat-elevation-z0 author__table font-montserrat"
    >
      <ng-container matColumnDef="Name">
        <th mat-header-cell *matHeaderCellDef>Topic</th>
        <td mat-cell *matCellDef="let topic" class="py-3">
          <a color="primary" [routerLink]="['./', topic.id]">{{
            topic.displayName
          }}</a>
        </td>
      </ng-container>
      <ng-container matColumnDef="Parent">
        <th mat-header-cell *matHeaderCellDef>Parent topic</th>
        <td mat-cell *matCellDef="let topic" class="py-3">
          {{ getParentName(topic) }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Sites">
        <th mat-header-cell *matHeaderCellDef>Sites</th>
        <td mat-cell *matCellDef="let topic" class="py-3">
          {{ topic.channels?.length || 0 }} site(s)
        </td>
      </ng-container>
      <ng-container matColumnDef="Actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let topic" class="py-3">
          <a
            [routerLink]="['./', topic.id]"
            title="Edit topic"
            class="px-1 hover:text-project-300"
          >
            <mat-icon inline>edit</mat-icon>
          </a>
          <button
            type="button"
            title="Delete topic"
            class="px-1 hover:text-project-300"
            (click)="deleteTopic(topic)"
          >
            <mat-icon inline>delete</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns"
        class="px-4 py-3 border-t bg-project-600 border-t-project-700"
      ></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <div
      class="flex items-center justify-between px-4 py-3 border-t bg-project-600 border-t-project-700"
    >
      <div>
        <button
          class="bg-none border border-project-50 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-project-100"
          (click)="loadTopics()"
          title="Refresh"
        >
          <i class="icon icon-refresh"></i>
        </button>
        <mat-form-field
          [floatLabel]="'never'"
          class="w-16 text-sm leading-[0.99rem] author__page-select"
          appearance="outline"
          title="Number of entries per page"
        >
          <mat-select [formControl]="pageSizeFilter">
            <mat-option *ngFor="let page of pagingOptions" [value]="page">
              {{ page }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <span class="font-montserrat">per page</span>
      </div>
      <div>
        <button
          class="bg-none border border-project-100 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-project-100 disabled:border-project-100"
          [disabled]="!dataSource?.paginator?.hasPreviousPage()"
          (click)="cmsPaginationService.previousPage(dataSource)"
        >
          Previous
        </button>
        <button
          *ngFor="let num of cmsPaginationService.pageNumbers"
          class="bg-none border border-project-50 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-white"
          (click)="cmsPaginationService.selectPage(dataSource, num)"
          [disabled]="cmsPaginationService.isActivePage(dataSource, num)"
          [ngClass]="{
            'author__page-button--current': cmsPaginationService.isActivePage(
              dataSource,
              num
            )
          }"
        >
          {{ num }}
        </button>
        <button
          class="bg-none border border-project-100 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-project-100 disabled:border-project-100"
          (click)="cmsPaginationService.nextPage(dataSource)"
          [disabled]="!dataSource?.paginator?.hasNextPage()"
        >
          Next
        </button>
      </div>
    </div>
  </div>
  <mat-paginator
    [pageSizeOptions]="[10, 25, 50, 100]"
    class="invisible"
  ></mat-paginator>
</div>
